<script lang="ts">
  import Label from '$provider/constants/Label';
  import type { DataListAlert } from '$provider/models/datalist/DataListAlert';
  import { ListAlertType } from '../ListAlertProps';
  import AlertView from './AlertView.svelte';

  interface Props {
    alert: DataListAlert;
  }

  let { alert }: Props = $props();
</script>

<AlertView type={ListAlertType.Updated} key={Label.Updated} icon="icon-corner-down-right">
  {#snippet value()}
    <div  class="value">
      {alert.value}
    </div>
  {/snippet}
</AlertView>

<style>
  .value {
    width: 100%;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    color: vae(--grey-medium);
    padding: 12px 16px;
  }
</style>
